var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Search",
    d: "M28.228,30a1.781,1.781,0,0,1-1.282-.549l-8.206-8.21-.008.006a11.512,11.512,0,0,1-6.9,2.276h-.045a11.808,11.808,0,0,1-8.38-20.1A11.734,11.734,0,0,1,11.65,0H11.7A11.855,11.855,0,0,1,23.486,11.8a11.543,11.543,0,0,1-2.251,6.926l8.214,8.216A1.771,1.771,0,0,1,28.228,30ZM11.665,2.353A9.376,9.376,0,0,0,5.122,18.386a9.428,9.428,0,0,0,6.655,2.783h.036a9.409,9.409,0,0,0-.106-18.816Z",
    fill: "#cbc3d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.39fee4ed1a3704bff1aa13ecce1f5132.svg";
export { ForwardRef as ReactComponent };